import { render } from "./Shop.vue?vue&type=template&id=27e5735b&scoped=true"
import script from "./Shop.vue?vue&type=script&lang=js"
export * from "./Shop.vue?vue&type=script&lang=js"

import "./Shop.vue?vue&type=style&index=0&id=27e5735b&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e5735b"]])

export default __exports__